export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9682.ce7322eb.jpg";